import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { catalogApi, type Catalog, type Category } from '../../api/catalog';

export function SEOCategoriesPage() {
  const [catalogs, setCatalogs] = useState<Catalog[]>([]);
  const [catalogId, setCatalogId] = useState('');
  const [categories, setCategories] = useState<Category[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void catalogApi.listCatalogs().then((items) => {
      setCatalogs(items);
      if (items[0]?.id) setCatalogId(items[0].id);
    });
  }, []);

  useEffect(() => {
    if (!catalogId) return;
    void catalogApi.listCategories({ catalog_id: catalogId }).then(setCategories).catch((e) => setError(String(e)));
  }, [catalogId]);

  const withSeo = categories.filter((c) => c.seo?.title || c.seo?.description || c.seo?.keywords);
  const withoutSeo = categories.filter((c) => !c.seo?.title && !c.seo?.description && !c.seo?.keywords);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/catalog" className="text-sm text-slate-600 hover:underline">← Catalogs</Link>
      <h1 className="mt-4 text-2xl font-semibold">SEO Categories</h1>
      <p className="mt-1 text-sm text-slate-600">Category SEO metadata and optimization coverage.</p>
      <select value={catalogId} onChange={(e) => setCatalogId(e.target.value)} className="mt-4 rounded-lg border px-3 py-2 text-sm">
        {catalogs.map((c) => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <div className="rounded-xl border bg-white p-4">
          <p className="text-sm text-slate-500">Total categories</p>
          <p className="mt-1 text-2xl font-semibold">{categories.length}</p>
        </div>
        <div className="rounded-xl border bg-white p-4">
          <p className="text-sm text-slate-500">With SEO</p>
          <p className="mt-1 text-2xl font-semibold text-emerald-700">{withSeo.length}</p>
        </div>
        <div className="rounded-xl border bg-white p-4">
          <p className="text-sm text-slate-500">Missing SEO</p>
          <p className="mt-1 text-2xl font-semibold text-amber-700">{withoutSeo.length}</p>
        </div>
      </div>
      <div className="mt-6 overflow-x-auto rounded-xl border bg-white">
        <table className="min-w-full text-sm">
          <thead className="border-b bg-slate-50 text-left text-slate-600">
            <tr>
              <th className="px-4 py-3">Category</th>
              <th className="px-4 py-3">SEO title</th>
              <th className="px-4 py-3">Description</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody>
            {categories.map((c) => (
              <tr key={c.id} className="border-b">
                <td className="px-4 py-3 font-medium">{c.name}</td>
                <td className="px-4 py-3">{c.seo?.title ?? '—'}</td>
                <td className="px-4 py-3 max-w-xs truncate">{c.seo?.description ?? '—'}</td>
                <td className="px-4 py-3">
                  <Link to={`/catalog/categories/${c.id}/edit`} className="text-slate-700 hover:underline">Edit</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
